export enum GPLUCoverageDefinitionType {
  AccelDeathBenefitCoverage = 'AccelDeathBenefitCoverage',
  ChildTLCoverage = 'ChildTLCoverage',
  SPOUSE_WL = 'SpouseWLCoverage',
  WL = 'WLCoverage',
}

export const spouseOrder = ['WS', 'NWS'];

export const MISSING_PLAN_ERROR_KEY = 'GPLUMasterBenefitPolicyPackage';

export enum GPLUCoverageCode {
  ACCEL_DEATH_BENEFIT_LIFE = 'AccelDeathBenefit',
  CHILD_TERM_LIFE = 'ChildTermLife',
  SPOUSE_WHOLE_LIFE = 'SpouseWholeLife',
  WHOLE_LIFE = 'WholeLife',
}

export enum AccelDeathBenefitType {
  LTC_Basic = 'LTCBasic',
  LTC_Restoration_Extension = 'LTCRestorationAndExtension',
}

export const GPLU_COVERAGE_CODE_TO_COVERAGE_TYPE_MAP = {
  [GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE]: GPLUCoverageDefinitionType.AccelDeathBenefitCoverage,
  [GPLUCoverageCode.CHILD_TERM_LIFE]: GPLUCoverageDefinitionType.ChildTLCoverage,
  [GPLUCoverageCode.SPOUSE_WHOLE_LIFE]: GPLUCoverageDefinitionType.SPOUSE_WL,
  [GPLUCoverageCode.WHOLE_LIFE]: GPLUCoverageDefinitionType.WL,
} as const;

export const GPLU_COVERAGE_CODE_TO_COVERAGE_NAME_MAP = {
  [GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE]: 'Accel. Death Benefit (LTC) Rider',
  [GPLUCoverageCode.CHILD_TERM_LIFE]: "Children's Term Rider",
  [GPLUCoverageCode.SPOUSE_WHOLE_LIFE]: 'Spouse Whole Life',
  [GPLUCoverageCode.WHOLE_LIFE]: 'Participant Whole Life',
} as const;

export const CONRACTED_COMPENSATION_FIELD_ID = {
  commissionStyle: 'quote.commissionStyle',
  quotedEnrollmentType: 'quote.quotedEnrollmentType',
  quotedCommissionSeries: 'quote.quotedCommissionSeries',
  quotedCommissionLevel: 'quote.quotedCommissionLevel',
  quotedCommissionRate: 'quote.quotedCommissionRate',
  quotedCommissionFYRate: 'quote.quotedCommissionFYRate',
  quotedCommissionRenewalRate: 'quote.quotedCommissionRenewalRate',
} as const;

export const GPLU_WHOLE_LIFE_FIELD_ID = {
  benefitTypeCd: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitSchedule.benefitTypeCd`,
  benefitMaxAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitScheduleRangeValues.benefitMaxAmount`,
  benefitMinAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitScheduleRangeValues.benefitMinAmount`,
  censusClassCoverageGroupsLinks: `plan.GPLUCoverageDefinition.coverageGroupsLinks`,
  flatBenefitAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitScheduleSingleValue.flatBenefitAmount`,
  guaranteedIssueAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUUnderwriting.guaranteedIssueAmount`,
  incrementAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitScheduleRangeValues.incrementAmount`,
  maxAcceleratedBenefitPct: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUAcceleratedBenefitOptions.maxAcceleratedBenefitPct`,
  maxAcceleratedBenefitAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUAcceleratedBenefitOptions.maxAcceleratedBenefitAmount`,
  payrollFrequencyCd: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitCoverageFundingStructure.payrollFrequencyCd`,
  rateFormatCd: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitCoverageRatingDetails.rateFormatCd`,
  specifiedBenefitAmount: `plan.${GPLUCoverageCode.WHOLE_LIFE}.GPLUBenefitScheduleMultipleValues.specifiedBenefitAmount`,
} as const;

export const GPLU_ACDB_FIELD_ID = {
  eliminationPeriod: `plan.${GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}.AccelDeathBenefitCoverage.eliminationPeriod`,
  monthlyDeathBenefitPct: `plan.${GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}.GPLUBenefitScheduleLTCChronic.monthlyDeathBenefitPct`,
  rateFormatCd: `plan.${GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}.GPLUBenefitCoverageRatingDetails.rateFormatCd`,
} as const;

export const GPLU_SPOUSE_WHOLE_LIFE_FIELD_ID = {
  WS: {
    benefitTypeCd: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleWs.benefitTypeWsCd`,
    benefitMaxAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleRangeValuesWs.benefitMaxAmount`,
    benefitMinAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleRangeValuesWs.benefitMinAmount`,
    flatBenefitAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleSingleValueWs.flatBenefitAmount`,
    guaranteedIssueAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUSpouseUnderwritingAmountsWs.guaranteedIssueAmount`,
    incrementAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleRangeValuesWs.incrementAmount`,
    specifiedBenefitAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleMultipleValuesWs.specifiedBenefitAmount`,
  },
  NWS: {
    benefitTypeCd: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleNws.benefitTypeNwsCd`,
    benefitMaxAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleRangeValuesNws.benefitMaxAmount`,
    benefitMinAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleRangeValuesNws.benefitMinAmount`,
    flatBenefitAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleSingleValueNws.flatBenefitAmount`,
    guaranteedIssueAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUSpouseUnderwritingAmountsNws.guaranteedIssueAmount`,
    incrementAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleRangeValuesNws.incrementAmount`,
    specifiedBenefitAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitScheduleMultipleValuesNws.specifiedBenefitAmount`,
  },
  maxAcceleratedBenefitPct: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUAcceleratedBenefitOptions.maxAcceleratedBenefitPct`,
  maxAcceleratedBenefitAmount: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUAcceleratedBenefitOptions.maxAcceleratedBenefitAmount`,
  payrollFrequencyCd: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitReducedFundingStructure.payrollFrequencyCd`,
  rateFormatCd: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUBenefitCoverageRatingDetails.rateFormatCd`,
  spouseCoveredOption: `plan.${GPLUCoverageCode.SPOUSE_WHOLE_LIFE}.GPLUSpouseCoveredMultipleValues.spouseWorkingOptionsCd`,
} as const;

export const GPLU_CHILD_TERM_LIFE_FIELD_ID = {
  benefitTypeCd: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitSchedule.benefitTypeCd`,
  benefitMaxAmount: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitScheduleRangeValues.benefitMaxAmount`,
  benefitMinAmount: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitScheduleRangeValues.benefitMinAmount`,
  incrementAmount: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitScheduleRangeValues.incrementAmount`,
  flatBenefitAmount: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitScheduleSingleValue.flatBenefitAmount`,
  specifiedBenefitAmount: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitScheduleMultipleValues.specifiedBenefitAmount`,
  guaranteedIssueAmount: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUUnderwriting.guaranteedIssueAmount`,
  rateFormatCd: `plan.${GPLUCoverageCode.CHILD_TERM_LIFE}.GPLUBenefitCoverageRatingDetails.rateFormatCd`,
} as const;

export const AccelDbRateFormatCd = {
  'AgeBanded-Uni-Tobacco': 'AgeBanded-Uni-Tobacco',
  'AgeSpecific-Uni-Tobacco': 'AgeSpecific-Uni-Tobacco',
} as const;

export const PwlRateFormatCd = {
  'AgeBanded-TobaccoDistinct': 'AgeBanded-TobaccoDistinct',
  'AgeSpecific-TobaccoDistinct': 'AgeSpecific-TobaccoDistinct',
} as const;

export const ctlrMinGIAmount = 5000;
export const ctlrMaxGIAmount = 20000;

export const GPLU_SPOUSE_TYPE = {
  WS: 'WS',
  NWS: 'NWS',
} as const;
